module.exports = __webpack_public_path__ + "img/ic_food_chicken.4e267936.png";